var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconTogglesLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m49.81,30.75H6.77V14.34h43.04c4.1,0,7.42,3.32,7.42,7.42v1.58c0,4.1-3.32,7.42-7.42,7.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m43.25,51.4H6.77v-14.83h36.47c4.1,0,7.42,3.32,7.42,7.42h0c0,4.1-3.32,7.42-7.42,7.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconTogglesLeft);
export default __webpack_public_path__ + "static/media/SDS_icon_Toggles_Left.b17fb8dbb9f5cb2e15b15009ae827a0c.svg";
export { ForwardRef as ReactComponent };